import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmployeeQualificationComponent } from './employee-qualification/employee-qualification.component';
import { QualificationApproverComponent } from './qualification-approver/qualification-approver.component';
import { EmployeeResolver } from 'src/app/shared/resolvers/employee.resolver';
import { ModuleGuard } from 'src/app/shared/guards/module.guard';
import { ExperienceViewComponent } from './experience/experience-view/experience-view.component';
import { ExperienceListComponent } from './experience/experience-list/experience-list.component';

const routes: Routes = [
  {
      path: 'employee-qualification',
      component: EmployeeQualificationComponent,
      resolve: { employeeId: EmployeeResolver},
      canActivate:[ModuleGuard],
      data: {
        title: 'qualification',
        modules:['QUALIFICATION']
      }
    },
    {
      path: 'employee-qualificationList',
      component: QualificationApproverComponent,
      resolve: { employeeId: EmployeeResolver},
      canActivate:[ModuleGuard],
      data: {
        title: 'qualification-approver',
        modules:['QUALIFICATION APPROVAL']
      }
    },

    {
      path: 'experiences',
      canActivate:[ModuleGuard],
      component: ExperienceListComponent,
      resolve: { employeeId: EmployeeResolver},
      data: {
        title: 'experience',
        modules:['EXPERIENCE'],
        
      }
    },
    {
      path: 'experience-approval',
      canActivate:[ModuleGuard],
      component: ExperienceViewComponent,
      resolve: { employeeId: EmployeeResolver},
      data: {
        title: 'experience',
        modules:['EXPERIENCE APPROVAL'],
        
      }
    },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PersonalRoutingModule { }
